import styled from 'styled-components';

export const StyledContainer = styled.section`
  width: 100%;
  min-height: 100vh;
  background-color: #030617;
  margin: 0 auto;
  text-align: center;
`;
